import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PriceChange, PriceChangeStatus } from "./model/price-change";
import { Page } from "src/app/util/page";

@Injectable()
export class PriceChangeService {

  constructor(private httpClient: HttpClient) { }

  public countByStatus(statuses: PriceChangeStatus[]): Observable<Number> {
    return this.httpClient.get<Number>(`/api/inventory/price-change?count&${this.params(statuses)}`);
  }

  public updateStatus(id: string, status: PriceChangeStatus): Observable<HttpResponse<void>> {
    return this.httpClient.post<HttpResponse<void>>(`/api/inventory/price-change/${id}?status=${status}`, {});
  }

  public findByStatus(statuses: PriceChangeStatus[]): Observable<Page<PriceChange>> {
    var params = this.params(statuses);

    return this.httpClient.get<Page<PriceChange>>(`/api/inventory/price-change${params != "" ? "?" + params : ""}`);
  }

  params(statuses: PriceChangeStatus[]): string {
    var params = "";
    for (let status of statuses) {
      if (params != "?") {
        params += "&";
      }
      params += `status=${status}`;
    }

    return params;
  }
}